module.exports = __webpack_public_path__ + "static/img/cgal13.ff5b69d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal13.png
// module id = q4xH
// module chunks = 1